@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Schedule'"
      [linkIcon]="'add-circle'"
      [showLinkIcon]="true"
      (linkAction)="onFABButtonClick()"
      />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper
    [hasBottomNav]="true"
    [isPrimaryLayer]="true"
    (contentHeight)="contentHeight = $event"
    [ngClass]="{'flex-content': windowService.isDesktopRes}">



    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-schedule-weekly-filter
      [isLoading]="!isScheduleDataLoaded && addressResponse?.length !== 0 && (scheduleViewMode === 'DAY' || scheduleViewMode === 'LIST')"
      [loaded]="loaded"
      [addresses]="addressResponse"
      [selectedPeriodRange]="selectedPeriodRange"
      [initialAddressFilter]="initialAddressFilter"
      [initialFilters]="propertiesFilters"
      [showAboutThisPage]="showAboutThisPage"
      (filter)="onFilterChanges($event)"
      (searchChange)="onSearchChanges($event)"
      (goToPreviousPeriod)="goToPreviousPeriod()"
      (goToNextPeriod)="goToNextPeriod()"
      (changeScheduleViewMode)="changeScheduleViewMode($event)"
      (dateRangeChange)="onDateRangeChange($event)"
      (addOwnerBlock)="openAddOwnerBlock()"
      [showLoadingSpinner]="showLoadingSpinner"/>

    @if (loaded && addressResponse?.length === 0) {
      <tidy-card>
        <tidy-row [align]="'center'">
          <tidy-text [body]="'Add a property to view your schedule.'" /><span>&nbsp;</span>
          <tidy-text
            [actionBody]="'Add Property'"
            class="link"
            (action)="goToDashboard()" />
        </tidy-row>
      </tidy-card>
    }

    @if (scheduleViewMode === 'MONTHLY' && addressResponse?.length > 0) {
      <div class="remove-wrapper-margin">
        <tidy-schedule-monthly-view
          [properties]="schedule.properties"
          [selectedPeriodRange]="selectedPeriodRange"
          [isLoading]="isLoadingSchedule"
          (clickAction)="handleClickActionMonthlyView($event)" />
      </div>
    }
    <!-- Calendar-shaped skeleton (desktop, weekly modes): shows from landing
         until the weekly view reports readiness, so its float-in wave plays
         once, uncut, and the real grid then replaces it in place instantly.
         The weekly view below mounts hidden meanwhile (no header loader). -->
    @if (windowService?.isDesktopRes
      && (scheduleViewMode === 'SEVEN_DAYS' || scheduleViewMode === 'WEEK_MON_SUN')
      && addressResponse?.length !== 0
      && (!isScheduleDataLoaded || !isWeeklyViewReady)) {
      <div class="remove-wrapper-margin">
        <tidy-schedule-weekly-skeleton />
      </div>
    }
    @if (isScheduleDataLoaded && addressResponse?.length > 0) {
      @if (schedule.properties?.length === 0 && propertiesSearch) {
        <tidy-alert>
          <tidy-text [body]="'No results found'" />
        </tidy-alert>
      }
      @if (scheduleViewMode === 'SEVEN_DAYS' || scheduleViewMode === 'WEEK_MON_SUN') {
        <div class="remove-wrapper-margin" [style.display]="!windowService?.isDesktopRes || isWeeklyViewReady ? '' : 'none'">
          <tidy-schedule-weekly-view
            [isMobileResolution]="!windowService?.isDesktopRes"
            [properties]="schedule.properties"
            [daysOfWeek]="daysOfWeek"
            [selectedPeriodRange]="selectedPeriodRange"
            [viewMode]="scheduleViewMode"
            [showAboutThisPage]="showAboutThisPage"
            (clickAction)="handleClickAction($event)"
            (assignedPro)="handleAssignedPro($event)"
            (readinessChange)="isWeeklyViewReady = $event" />
        </div>
      }
      @if (scheduleViewMode === 'DAY') {
        <div class="remove-wrapper-margin">
          <tidy-schedule-day-view
            [isMobileResolution]="!windowService?.isDesktopRes"
            [properties]="schedule.properties"
            [selectedPeriodRange]="selectedPeriodRange"
            [showAboutThisPage]="showAboutThisPage"
            (clickAction)="handleClickAction($event)" />
        </div>
      }
      @if (scheduleViewMode === 'LIST') {
        <div>
          <tidy-schedule-list-view
            [isMobileResolution]="!windowService?.isDesktopRes"
            [properties]="schedule.properties"
            [selectedPeriodRange]="selectedPeriodRange"
            (clickAction)="handleClickAction($event)"
            (onClickAction)="handleClickAction($event)"
            (requestMoreData)="handleRequestMoreData($event)" />
        </div>
      }
    }

    <!--<div style="margin-bottom: 100px" [ngStyle]="!windowService?.isDesktopRes ? {'margin-top': '-80px'} : {}"  *ngIf="addressResponse?.length == 1 && !addressResponse[0]?.integration?.name && !hasJobsAtOnlyAddress">
    <tidy-row class="extra-top-padding extra-bottom-padding">
      <tidy-text
        [header]="'Start Using Your Calendar:'">
      </tidy-text>
    </tidy-row>

    <tidy-card class="vertical-align-center" style="padding: 15px 15px 15px 15px">
      <tidy-card-button (action)="bookJobSelectAddress()">
        <tidy-row>
          <ion-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/book-job.svg'"
                style="width:40px;height:50px">
              </tidy-image>
            </tidy-row>
            <ion-col>
              <tidy-row>
                <tidy-text
                  [header]="'Instantly Book'">
                </tidy-text>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'Book or manage your pros instantly, or find a new one.'">
                </tidy-text>
              </tidy-row>
            </ion-col>
          </ion-row>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card class="vertical-align-center" style="padding: 15px 15px 15px 15px" *ngIf="isRentalClient">
      <tidy-card-button (action)="goToAllIntegrations()">
        <tidy-row>
          <ion-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/integration.svg'"
                style="width:40px;height:50px">
              </tidy-image>
            </tidy-row>
            <ion-col>
              <tidy-row>
                <tidy-text
                  [header]="'Sync Guest/Tenant Calendar'">
                </tidy-text>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'Integrate Airbnb or a property management tool to get guest check-ins or tenant move outs synced to your calendar, to make automation easy.'">
                </tidy-text>
              </tidy-row>
            </ion-col>
          </ion-row>
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
  </div>-->


</tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


<tidy-bottom-nav activeRoute="/schedule" />

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'schedule'" (dismissed)="dismissAboutThisPage()" />
}